import Quantity from 'components/global/Quantity'
import Box from 'components/shared/Box'
import Price from 'components/shared/Price'
import Text from 'components/shared/Text'
import { formatPrice } from 'helpers/helpers'
import { FormattedMessage } from 'react-intl'
import { useResolutions } from 'store/resolutions'
import { DiscountProductInfo } from './DiscountedProduct.style'
import { DiscountedProductProps } from './DiscountedProduct.types'

export const DiscountedProduct = ({
    quantity,
    valueBefore,
    valueAfter,
    unitPrice,
    title,
    subtitle,
    counterAlignment = 'center',
    hasBackToSchoolDisclaimer,
}: DiscountedProductProps) => {
    const { isTablet } = useResolutions()

    return (
        <Box align="flex-end" isFullWidth>
            <Box
                direction={isTablet ? 'row' : 'row'}
                justify="space-between"
                gap={8}
                isFullWidth
            >
                <Box
                    direction="row"
                    align={['baseline', counterAlignment]}
                    mt={[0, 6]}
                    isFullWidth={hasBackToSchoolDisclaimer}
                >
                    <Box mr={[8, 16]}>
                        <Quantity
                            value={quantity}
                            size={isTablet ? 'small' : 'big'}
                        />
                    </Box>
                    <Box direction="column" mt={[2, 0]}>
                        <Text variant="body" color="grayscale_900">
                            {title}
                        </Text>
                        {!isTablet && (
                            <Text
                                variant="bodySmall"
                                color="grayscale_700"
                                dangerouslySetInnerHTML={{
                                    __html: subtitle,
                                }}
                            />
                        )}
                    </Box>
                </Box>
                <Box
                    align="flex-end"
                    hasNoShrink={!hasBackToSchoolDisclaimer}
                    minWidth={
                        hasBackToSchoolDisclaimer && !isTablet ? 516 : undefined
                    }
                >
                    <Price
                        value={valueAfter}
                        color="grayscale_900"
                        size="heading3"
                    ></Price>
                    {!isTablet && (
                        <>
                            <Text
                                variant="bodyExtraSmall"
                                color="grayscale_700"
                                ml={32}
                            >
                                <FormattedMessage
                                    id="order.discount.regular_price"
                                    defaultMessage="Cena regularna:"
                                />{' '}
                                <span>{formatPrice(unitPrice, true)}</span>
                            </Text>
                        </>
                    )}
                </Box>
            </Box>
            {!isTablet && (
                <Text
                    variant="bodyExtraSmall"
                    color="grayscale_700"
                    ml={32}
                    align="right"
                >
                    {!hasBackToSchoolDisclaimer ? (
                        <FormattedMessage
                            id="order.discount.lowest_price_30_days_info"
                            defaultMessage="Najniższa cena z 30 dni przed wprowadzeniem obniżki:"
                        />
                    ) : (
                        <FormattedMessage
                            id="order.discount.lowest_price_30_days_info_with_disclaimer"
                            defaultMessage="Najniższa cena z 30 dni przed wprowadzeniem obniżki (cena w promocji dla osób od 16 do 26 r.ż. na bilety do 31 października 2023 r.):"
                        />
                    )}{' '}
                    <span>{formatPrice(valueBefore, true)}</span>
                </Text>
            )}
            {isTablet && (
                <Box isFullWidth>
                    <Box ml={32}>
                        <Text
                            variant="bodyExtraSmall"
                            color="grayscale_700"
                            dangerouslySetInnerHTML={{
                                __html: subtitle,
                            }}
                        />
                    </Box>
                    <DiscountProductInfo
                        isFullWidth
                        align={'flex-end'}
                        alignSelf={'flex-end'}
                        hasNoShrink
                    >
                        <Text
                            variant="bodyExtraSmall"
                            color="grayscale_700"
                            ml={32}
                        >
                            <FormattedMessage
                                id="order.discount.regular_price"
                                defaultMessage="Cena regularna:"
                            />{' '}
                            <span>{formatPrice(unitPrice, true)}</span>
                        </Text>
                        <Text
                            variant="bodyExtraSmall"
                            color="grayscale_700"
                            align={'right'}
                        >
                            {!hasBackToSchoolDisclaimer ? (
                                <FormattedMessage
                                    id="order.discount.lowest_price_30_days_info"
                                    defaultMessage="Najniższa cena z 30 dni przed wprowadzeniem obniżki:"
                                />
                            ) : (
                                <FormattedMessage
                                    id="order.discount.lowest_price_30_days_info_with_disclaimer"
                                    defaultMessage="Najniższa cena z 30 dni przed wprowadzeniem obniżki (cena w promocji dla osób od 16 do 26 r.ż. na bilety do 31 października 2023 r.):"
                                />
                            )}{' '}
                            <span>{formatPrice(valueBefore, true)}</span>
                        </Text>
                    </DiscountProductInfo>
                </Box>
            )}
        </Box>
    )
}

DiscountedProduct.displayName = 'DiscountedProduct'
